import React, { FC, useEffect } from 'react'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import ListGroup from 'react-bootstrap/ListGroup'
import Container from 'react-bootstrap/Container'
import Jumbotron from '../../components/Jumbotron'
import Button from 'react-bootstrap/Button'
import { Link, useHistory } from 'react-router-dom'
import useUserWithRole from '../../hooks/authentication/useUserWithRole'
import isAuthenticated from '../../routes/PrivateRoute'
import { useGlobalState } from '../../hooks/store/useGlobalState'
import PageTitle from '../../components/PageTitle'

const MemberHome: FC = () => {
  const { user, role } = useUserWithRole()
  const history = useHistory()
  const setFhirId = useGlobalState((state) => state.setFhirId)

  const handleNavigation = () => {
    setFhirId(user.memberId)
    history.push('/patient')
  }

  useEffect(() => {
    if (role === 'member') {
      setFhirId(user.memberId)
      history.replace('/patient')
    }
  }, [role])

  return (
    <Container
      id='MemberHome'
      style={{
        paddingTop: 10,
        paddingBottom: 10,
      }}
    >
      <Row>
        <Col md={3} className='p-3 border'>
          <PageTitle displayName="Member Home" />
          <h3>Member Menu</h3>
          <ListGroup as='ul' variant='flush' className='m-0 p-0'>
            <ListGroup.Item as='li' className='mb-1 p-1'>
              <Link to='/available-apps'>Available Apps</Link>
            </ListGroup.Item>
          </ListGroup>
        </Col>

        <Col md={9} className='p-3 border'>
          <Jumbotron>
            <div>
              <h1>Hello {user.accountOwner}</h1>
              <h3 className='text-muted mt-2'>Member Name: {user.name}</h3>
              <h3 className='text-muted mt-2'>Member ID: {user.memberId}</h3>
              <p className='memberParagraph'>
                Please check out the list of <Link to='/available-apps' style={{ color: '#047fbb' }}> Available Apps </Link> that you can use to connect to your health information at CCHP, Together with CCHP or Care4Kids.
              </p>
              <Button onClick={handleNavigation}>Navigate to Profile</Button>
            </div>
          </Jumbotron>
        </Col>
      </Row>
    </Container>
  )
}

export default isAuthenticated(MemberHome)